import { Rule } from "antd/lib/form";

// TODO: Re-enable once URL-safe tag handling is in place.
const TAG_LABEL_VALIDATION_ENABLED = false;

// Characters that break URLs or comma-separated tag lists when interpolated into query params.
const INVALID_TAG_LABEL_CHARACTERS = /[$+,;&=#?%/\\"'()[\]@!]/;

export const TAG_LABEL_INVALID_CHARS_MESSAGE =
  "Tag names cannot contain special characters ($, +, ,, &, ;, =, #, ?, %, /)";

export function hasInvalidTagLabelCharacters(value?: string): boolean {
  if (!TAG_LABEL_VALIDATION_ENABLED || !value?.trim()) {
    return false;
  }
  return INVALID_TAG_LABEL_CHARACTERS.test(value);
}

export const tagLabelValidationRules: Rule[] = TAG_LABEL_VALIDATION_ENABLED
  ? [
      {
        validator: (_, value: string) => {
          if (!value?.trim()) {
            return Promise.resolve();
          }
          if (hasInvalidTagLabelCharacters(value)) {
            return Promise.reject(new Error(TAG_LABEL_INVALID_CHARS_MESSAGE));
          }
          return Promise.resolve();
        },
      },
    ]
  : [];
